import { Container, Stack } from "@mantine/core";
import { useListEvents } from "../hooks/useListEvents";
import { Vortrag } from "./Vortrag";

export const Vorträge = () => {
  const eventsQuery = useListEvents();

  if (!eventsQuery.isSuccess) {
    return <>Lade Vorträge</>;
  }

  if (eventsQuery.isError) {
    return <>Fehler beim Laden der Vorträge</>;
  }

  const events = eventsQuery.data.events;

  return (
    <>
      <Container size="lg">
        <Stack gap="xl">
          {events.map((e) => (
            <Vortrag key={e.id} event={e} />
          ))}
        </Stack>
      </Container>
    </>
  );
};
